import { render, staticRenderFns } from "./UserEditTabAccount.vue?vue&type=template&id=1ec4eaa5"
import script from "./UserEditTabAccount.vue?vue&type=script&lang=js"
export * from "./UserEditTabAccount.vue?vue&type=script&lang=js"
import style0 from "./UserEditTabAccount.vue?vue&type=style&index=0&id=1ec4eaa5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports